module.exports = __webpack_public_path__ + "img/block-activity.1c2ca8d7.png";